import { __rest } from "tslib";
import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { Select } from 'antd';
import styles from './index.module.scss';
const SiriusSelect = (_a) => {
    var { label, defaultValue, overClass, labelClass, wrapClass, options, onChange, size = 'small' } = _a, restProps = __rest(_a, ["label", "defaultValue", "overClass", "labelClass", "wrapClass", "options", "onChange", "size"]);
    const [value, setValue] = useState(defaultValue);
    useEffect(() => {
        setValue(defaultValue);
    }, [defaultValue]);
    return (React.createElement("div", { className: classnames(styles.siriusSelectWrap, wrapClass) },
        label && React.createElement("div", { className: classnames(styles.siriusSelectLabel, labelClass) }, label),
        React.createElement(Select, Object.assign({}, restProps, { size: size, onChange: value => {
                onChange && onChange(value);
                setValue(value);
            }, className: classnames(styles.siriusSelectContent, overClass), listItemHeight: 30, suffixIcon: React.createElement("i", { className: `dark-invert ${styles.siriusSelectSuffixIcon}` }), dropdownClassName: `ant-allow-dark ${styles.siriusSelectDropDown}`, value: value }), options.map(r => (React.createElement(Select.Option, { className: styles.siriusSelectOption, key: r.value, value: r.value }, r.label))))));
};
export default SiriusSelect;
